import { render } from "./MobileBottomBar.vue?vue&type=template&id=3194284f&scoped=true"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js"

import "./MobileBottomBar.vue?vue&type=style&index=0&id=3194284f&scoped=true&lang=css"
import "./MobileBottomBar.vue?vue&type=style&index=1&id=3194284f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3194284f"]])

export default __exports__